<template>
  <div class="truncate-list">
    <vs-list-item
      v-for="(item, index) in displayedItems"
      :key="item.id"
      :subtitle="item.nomeGrupo"
    ></vs-list-item>
    ...
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    maxItems: {
      type: Number,
      default: 3, // Número máximo de itens a serem exibidos antes de truncar
    },
  },
  data() {
    return {
      isTruncated: true,
    };
  },
  computed: {
    displayedItems() {
      return this.isTruncated ? this.items.slice(0, this.maxItems) : this.items;
    },
    hasMoreItems() {
      return this.items.length > this.maxItems;
    },
  },
  methods: {
    toggleExpand() {
      this.isTruncated = !this.isTruncated;
    },
  },
};
</script>

<style scoped>
.toggle-link {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
  position: relative; /* Necessário para que o z-index funcione */
  z-index: 9999; /* Define um z-index alto */
}
</style>
